<template>
    <div class="bg-white p-3">
       <div class="w-full">
        <page-header
        heading="Settings"
        breadcrumb="7th June, 2021"
      />
       </div>
      
      <div class="flex justify-around flex-wrap items-center w-full mt-20">
        <div class="md:w-10/12 w-full flex  justify-around gap-6 mb-10 cursor-pointer">
            <div @click="$router.push('/settings/organization-information')" class="w-4/12 flex justify-center flex-wrap">
                <img src="@/assets/images/ondemand/account-profile.svg"/>
                <b class="block w-full text-center py-2">Account Profile</b>
                <p class="block w-full text-center">User profile and organization
                    details.</p>
            </div>

            <div class="w-4/12 flex justify-center flex-wrap cursor-pointer" @click="$router.push('/settings/domain')">
                <img src="@/assets/images/ondemand/domain.svg"/>
                <b class="block w-full text-center py-2">Roles and Privileges</b>
                <p class="block w-full text-center">Set up roles & privileges for your shipments</p>
            </div>

            <div @click="$router.push('/settings/account-security')" class="w-4/12 flex justify-center flex-wrap">
                    <img src="@/assets/images/ondemand/security.svg"/>
                    <b class="block w-full text-center py-2">Admins</b>
                    <p class="block w-full text-center">Set up admins
                        for your shipments</p>
            </div>
        </div>

        <div class="md:w-10/12 w-full mt-5 flex  justify-around gap-6 cursor-pointer">
            <div   @click="$router.push('/settings/account-security')" class="w-4/12 flex justify-center flex-wrap">
                <img src="@/assets/images/ondemand/security.svg"/>
                <b class="block w-full text-center py-2">Security</b>
                <p class="block w-full text-center">Security policies (passwords,
                    2FA, & security questions).</p>
            </div>

            <div @click="$router.push('/settings/payment')" class="w-4/12 flex justify-center flex-wrap">
                <img src="@/assets/images/ondemand/payment.svg"/>
                <b class="block w-full text-center py-2">Payments</b>
                <p class="block w-full text-center">Select and set up preferred payment
                    methods for your shipments</p>
            </div>

            <div @click="$router.push('/settings/preferences')" class="w-4/12 flex justify-center flex-wrap">
                    <img src="@/assets/images/ondemand/security.svg"/>
                    <b class="block w-full text-center py-2">Preferences</b>
                    <p class="block w-full text-center">Set up preferences
                        for your shipments</p>
            </div>
        </div>

        <!-- <div class="md:w-10/12 w-full mt-5 flex justify-around gap-6 cursor-pointer"
        >
            <div class="w-4/12 flex justify-center flex-wrap cursor-pointer" @click="$router.push('/customer/locations')">
                <img src="@/assets/images/ondemand/domain.svg"/>
                <b class="block w-full text-center py-2">Locations</b>
                <p class="block w-full text-center">Set location(s).</p>
            </div>
            <div   @click="$router.push('/settings/account-security')" class="w-4/12 flex justify-center flex-wrap">
                <img src="@/assets/images/ondemand/security.svg"/>
                <b class="block w-full text-center py-2">Users</b>
                <p class="block w-full text-center">Add users</p>
            </div>
        </div> -->
      </div>
    </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader.vue";

    export default {
        components: {
            PageHeader
        }
    }
</script>

<style lang="scss" scoped>

</style>